import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function CreateProgress(props) {
    const [progress, setProgress] = useState({
        progress: 0,
        elapsed: 0,
        remaining: 60,
    });
    const [status, setStatus] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((progress) => {
                // console.log("progress", progress);
                return {
                    start: progress.start || Date.now(),
                    elapsed: progress.elapsed + 0.05,
                    remaining: Math.max(0, progress.remaining - 0.05),
                    progress: Math.min(
                        99,
                        Math.round(
                            (1.0 -
                                progress.remaining /
                                    (progress.elapsed + progress.remaining)) *
                                100
                        )
                    ),
                };
            });
        }, 100);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (props.status !== status && props.status?.startsWith("queued_")) {
            setStatus(props.status);
            const queueCount = parseInt(props.status.split("queued_")[1]);
            // console.log("updating progress");
            setProgress((progress) => ({
                ...progress,
                remaining: (queueCount + 1) * 20,
            }));
        } else if (props.status !== status && props.status === "active") {
            setProgress((progress) => ({
                ...progress,
                remaining: 25,
            }));
        }
    }, [props.status]);

    const { theme } = useTheme();

    return (
        <div className="absolute my-16 flex items-center justify-center content-center">
            <div className="w-24 flex flex-col items-center justify-center">
                <CircularProgressbar
                    value={progress.progress}
                    text={`${
                        progress.start
                            ? ((Date.now() - progress.start) / 1000).toFixed(1)
                            : 0
                    }s`}
                    styles={buildStyles({
                        pathColor: `#25ec7e`,
                        textColor: props.hasImage
                            ? theme === "dark"
                                ? "#f6f6f6"
                                : "#f6f6f6"
                            : theme === "dark"
                            ? "#f6f6f6"
                            : "#333",
                    })}
                    className={
                        props.hasImage ? "progress-image" : "progress-no-image"
                    }
                />
            </div>
        </div>
    );
}
